import Reveal from '@/components/base/Reveal';
import { Link } from 'react-router-dom';

export default function Cta() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
        <Reveal>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm border border-accent-200">
            技术交付与系统实现
          </div>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            让每一项技术，都落到真实场景
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            华辉数智承担九畴云铺核心技术系统的研发、交付与系统集成，从 TOMA 智能体、数字货架到物联网连接，形成完整的技术服务链。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to="/demo"
              className="px-8 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
            >
              进入项目演示
            </Link>
            <Link
              to="/jiuchou"
              className="px-8 py-3 rounded-md border border-primary-400 text-primary-600 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-50"
            >
              了解九畴云铺
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}